import { useMemo } from 'react';
import {
  usePersistedSessionState,
  useShoppingType,
} from '@edreamsodigeo/frontend-core';

import type { ShoppingInfo } from '@/generated/graphql';
import { ShoppingType } from '@/generated/graphql';
import useShoppingId from './useShoppingId';

const useShoppingBundleInfo = (): ShoppingInfo => {
  const shoppingIdFromProviderOrURL = useShoppingId();
  const shoppingType = useShoppingType() as ShoppingType;
  const [bookingIdFromSession] = usePersistedSessionState('bookingId');
  const shoppingId =
    shoppingIdFromProviderOrURL || (bookingIdFromSession as number) || 0;
  return useMemo(
    () => ({
      shoppingId: `${shoppingId}`,
      shoppingType: shoppingType || ShoppingType.Cart,
    }),
    [shoppingId, shoppingType]
  );
};

export default useShoppingBundleInfo;
